import React from 'react';
import dynamic from 'next/dynamic';
const SurveyQuickForm = dynamic(
  import('../redesign/SurveyQuickForm/SurveyQuickForm.jsx')
);

import './Contacts.scss';
import icons from '../../shared/assets/icons';

const { Mail, Location } = icons;

export default function Contacts({
  user,
  addFormAnswer,
  submitFormAnswer,
  item
}) {
  return (
    <section className="contacts">
      <h2>Contact</h2>

      <div className="contacts-banner">
        Hey, ondervind je op dit moment technische problemen met onze dienst?
        Geen zorgen! Check even op{' '}
        <a
          href="https://status.zwangerenportaal.nl"
          target="_blank"
          rel="noopener noreferrer"
          className="contacts-banner-link"
        >
          status.zwangerenportaal.nl
        </a>{' '}
        of er een storing is. We staan voor je klaar!
      </div>

      <div className="contacts-content">
        <p>Zwangerenportaal.nl B.V</p>

        <ul>
          <li>
            <span>
              <Mail />
            </span>

            <div className="contacts-form">
              <SurveyQuickForm
                item={item}
                user={user}
                addFormAnswer={addFormAnswer}
                submitFormAnswer={submitFormAnswer}
              />
            </div>
          </li>

          <li>
            <span>
              <Location />
            </span>
            <p>Leeuwenhoekstraat 1, 2652 XL Berkel en Rodenrijs</p>
          </li>
        </ul>
      </div>
    </section>
  );
}
